import { useContext, useEffect, useState } from "react";
import { getOptionsSelectedText } from "src/utils/Functions";
import InputFilterBox from "../InputFilterBox/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { property_type_id } from "../options";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const PropertyTypeFilter = () => {
    const { filters } = useFilters();
    const { country_code } = useContext(ConfigStateContext);
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const [propertyTypeText, setPropertyTypeText] = useState('Tipo de Inmueble');

    const propertiesTypeByCountry = property_type_id.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : ""));
    const propertiesTypeList = propertiesTypeByCountry.map((type) => ({ text: type.text, value: type.value }))

    useEffect(() => {
        if (filters.property_type_id) {
            const text = getOptionsSelectedText(propertiesTypeByCountry, filters?.property_type_id)
            setPropertyTypeText(text)
        } else {
            setPropertyTypeText('Tipo de Inmueble')
        }
    }, [filters.property_type_id])

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentPropertiesTypeFilter = filters.property_type_id ?? []
        const { value, checked } = e?.target
        const parsedValue = Number(value)
        let updatedPropertiesTypeFilter = [];

        if (parsedValue === 0) {
            changeFilters({ property_type_id: [] });
        } else {
            if (checked) {
                updatedPropertiesTypeFilter = [...currentPropertiesTypeFilter, parsedValue];
            } else {
                updatedPropertiesTypeFilter = currentPropertiesTypeFilter.filter(b => b !== parsedValue);
            }

            const newPropertiesTypeFilter = propertiesTypeList.filter(item => updatedPropertiesTypeFilter.includes(item.value));

            changeFilters({ property_type_id: newPropertiesTypeFilter });
        }
    }

    return (
        <InputFilterBox label={propertyTypeText}>
            <div className="optionList">
                {propertiesTypeList?.map((val, i) => {
                    return (
                        <div key={val.text + "-" + i} className="optionList__option">
                            <input
                                type="checkbox"
                                className="checkBoxCustomInput"
                                onChange={handleOnChange}
                                name={"propertyTypeId"}
                                id={val.text}
                                value={val.value}
                                checked={
                                    ((typeof filters?.property_type_id === "undefined" || !filters?.property_type_id.length) && val?.value === 0) ||
                                    typeof filters?.property_type_id !== "undefined" && filters?.property_type_id.includes(val?.value)
                                }
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    );
                })}
            </div>
        </InputFilterBox>
    )
}
